import nester from "../assets/js/categoryNester.js";
// import normalizeManufacturers from "../assets/js/manufacturersListNormalizer.js";
import {
  normalizeSuppliers,
  filterOut as filterOutSuppliers,
} from "@/logic/supplierHelper.logic.js";
import {
  normalizeManufacturers,
  filterOut as filterOutManufacturers,
} from "@/logic/manufacturerHelperFunctions.logic.js";
import buildOrderBy from "@/logic/orderbystringbuilder.logic.js";
import { removeEm, replaceEm } from "@/helpers/emRemover.js";

export default {
  SET_RESULTS(state, data) {
    state.results = data;
    // console.log("results:");
    // console.log(data);

    state.itemIds = [];

    state.results.forEach((res) => {
      state.itemIds.push(res.document.ItemID);
      state.itemManufacturerIds.push(res.document.ManufacturerID);

      // highlighting
      if (res.highlights !== undefined) {
        // highlighting - ItemName
        if (res.highlights.ItemName !== undefined) {
          res.highlights.ItemName.forEach((hl) => {
            // remove <em></em> from the highlight
            let emlessText = removeEm(hl);
            res.document.ItemName = replaceEm(
              res.document.ItemName,
              emlessText,
              hl
            );
          });
        }
        // highlighting - Description
        if (res.highlights.Description !== undefined) {
          res.highlights.Description.forEach((hl) => {
            let emlessText = removeEm(hl);
            res.document.Description = replaceEm(
              res.document.Description,
              emlessText,
              hl
            );
          });
        }
      }
    });

    // console.log(state.itemIds);
  },

  SET_ITEMIMAGES(state, data) {
    // console.log("image data:");
    // console.log(data);

    data.forEach((item) => {
      state.results.find(
        (e) => e.document.ItemID == item.imageId
      ).document.thumbnail = item.image;
    });
  },

  SET_MANUFACTURERIMAGES(state, data) {
    console.log("manufacturer image data: ");
    console.log(data);
    // data.forEach((item) => {
    //   state.results.find(
    //     (e) => e.document.ManufacturerID == item.imageId
    //   ).document.manufacturerImage = item.image;
    // });

    // loop through results and glue up picture of manufacturer
    state.results.forEach((item) => {
      let man = data.find((e) => e.imageId == item.document.ManufacturerID);
      if (man !== undefined) {
        item.document.manufacturerImage = man.image;
      }
    });
  },

  SET_FACETS(state, data) {
    state.facets = data;

    console.log("Facets:");
    console.log(data);
  },

  FILTER_SUPPLIER_FACETS(state) {
    if (state.facets.ItemSuppliers !== undefined) {
      if (state.suppliers.length && !state.isPromo) {
        state.suppliers = filterOutSuppliers(
          state.allNormalizedSuppliers,
          state.facets.ItemSuppliers
        );
      }
    }
  },

  FILTER_MANUFACTURER_FACETS(state) {
    // set manufacturer facets
    if (state.facets.ManufacturerID !== undefined) {
      if (state.manufacturers.length && !state.isPromo) {
        state.manufacturers = filterOutManufacturers(
          state.allNormalizedManufacturers,
          state.facets.ManufacturerID
        );
      }
    }
  },

  SET_RESULTS_COUNT(state, count) {
    state.productsTotal = count;
  },

  SET_SEARCHSTRING(state, value) {
    console.log("mutations.js - SET_SEARCHSTRING: " + value);
    state.searchString = value;
  },

  SET_RAWSTRING(state, value) {
    state.rawString = value;
  },

  SET_RAW_STRING_STRICT(state, toggle) {
    if (state.rawString !== "") {
      if (!toggle) {
        state.rawString = '"' + state.rawString + '"';
      } else {
        state.rawString = state.rawString.replaceAll('"', "");
      }
    }
  },

  SET_FILTERS(state, payload) {
    if (payload.selected == null) {
      delete state.filters[payload.facet];
    } else {
      state.filters[payload.facet] = Array.isArray(payload.selected)
        ? payload.selected
        : payload.selected.split();
    }

    let allFilters = [];
    let allFiltersString = "";

    const keys = Object.keys(state.filters);
    keys.map((key) => {
      const filterArray = [];
      let filterString = "";
      state.filters[key].map((selectedValue) => {
        // handle query string for numbers or strings, add quotes depending
        const filter =
          typeof selectedValue === "number"
            ? selectedValue
            : `'${selectedValue}'`;
        return filterArray.push(`${key} eq ${filter}`);
      });
      filterString += filterArray.join(" or ");
      return allFilters.push(`(${filterString})`);
    });

    allFilters = allFilters.filter((f) => f.length && f !== "()");
    allFiltersString = allFilters.join(" and ");
    state.filterString = allFiltersString;
  },

  CLEAR_FILTERS(state) {
    state.filters = {};
    state.filterString = "";
  },

  SET_CURRENT_PAGE(state, page) {
    console.log("currentPage");
    console.log(page);
    state.currentPage = page;
  },

  SET_RESULTS_PER_PAGE(state, count) {
    state.resultsPerPage = count;
  },

  SET_ORDERBY(state, value) {
    state.orderBy = value;
  },

  SET_PRICESORTING(state, value) {
    state.priceSortingSelected = value;
    if (value !== null) {
      state.priceSortingIndex = value.id;
    } else {
      state.priceSortingIndex = 0;
    }
    console.log(state.priceSortingIndex);

    state.orderBy = buildOrderBy(state.priceSortingIndex);
    console.log(state.orderBy);
  },

  SET_PROMO(state, value) {
    state.isPromo = value;
  },

  updateFilteredManufacturerIds(state, ids) {
    state.filteredManufacturerIds = ids;
  },
  updatefilteredSupplierIds(state, ids) {
    state.filteredSupplierIds = ids;
  },
  SET_SELECTEDCATEGORYID(state, categoryId) {
    if (categoryId !== undefined) {
      state.selectedCategoryId = categoryId;
    } else {
      state.selectedCategoryId = null;
    }
  },
  setCategories(state, cdata) {
    state.cdata = cdata;
    state.categories = nester(cdata);
  },
  // setFilteredManufacturerIds(state, ids) {
  //   state.filteredManufacturerIds = ids;
  // },
  SET_MANUFACTURERS(state, mdata) {
    state.mdata = mdata;
    // console.log("mdata:");
    // console.log(mdata);
    state.allNormalizedManufacturers = normalizeManufacturers(mdata);
    state.allManufacturers = mdata;
    state.manufacturers = state.allNormalizedManufacturers;
    console.log("SET_MANUFACTURERS: state.manufacturers");
    console.log(state.manufacturers);
  },
  RESET_MANUFACTURERS(state) {
    state.manufacturers = state.allNormalizedManufacturers;
  },
  SET_SUPPLIERS(state, sdata) {
    state.sdata = sdata;
    state.allNormalizedSuppliers = normalizeSuppliers(sdata, state.products);
    state.allSuppliers = sdata;
    state.suppliers = state.allNormalizedSuppliers;
  },
  RESET_SUPPLIERS(state) {
    state.suppliers = state.allNormalizedSuppliers;
  },
  SET_SEARCH_STATUS(state, value) {
    state.currentSearchStatus = value;
  },
  // setProducts(state, pdata) {
  //   pdata.forEach((p) => {
  //     p.manufacturerImage = null;
  //     p.supplierImage = null;
  //   });
  //   state.products = pdata;
  //   console.log("lista proizvoda");
  //   console.log(pdata);
  //   state.productsTotal = pdata.length;
  //   state.manufacturers = normalizeManufacturers(state.mdata);
  //   state.suppliers = normalizeSuppliers(state.sdata, state.products);
  // },
};
